import * as types from '../actiontypes';

export const setIsChangeReasonRequired = (isChangeReasonRequired, showChangeReasonModal, parentName) => {
	return {
		type: types.SET_CHANGE_REASON_REQUIRED,
		isChangeReasonRequired,
		showChangeReasonModal,
		parentName
	};
};

export const showChangeReasonModal = (showChangeReasonModal, documentId) => {
	return {
		type: types.SHOW_CHANGE_REASON_MODAL,
		showChangeReasonModal: showChangeReasonModal,
		documentId: documentId
	};
};
